import withNavigate from "../../util/useNavigate";
import {withAppContext} from "../../util/withAppContext";
import withBreakpoint from "../../util/withBreakpoint";
import {EnlilTable2} from "../EnlilTable2";

class DocumentRevisionTable extends EnlilTable2 {


}

export default withNavigate(withAppContext(withBreakpoint(DocumentRevisionTable)));